import { DashboardFolderT, DashboardT } from 'business/definitions';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import DashboardEditMenu from 'components/DashboardEditMenu/DashboardEditMenu';
import { useFavouriteDashboardState } from 'ui/Card/hooks/useDashboardState';
import { isDashboardType } from './helpers';
import DashboardFolderEditMenu from 'routes/AllDashboards/components/DashboardFolderEditMenu/DashboardFolderEditMenu';
import Flex from 'ui/Flex/Flex';

export default function ActionCellRenderer({
    value,
}: CellRendererParams<
    DashboardT | DashboardFolderT
>): React.ReactElement | null {
    const isDashboard = isDashboardType(value);
    const { isFavourite, toggleFavourite } = useFavouriteDashboardState(
        isDashboard ? value : null,
    );
    if (!value) return null;
    return (
        <Flex
            sx={{
                justifyContent: 'center',
            }}
        >
            {isDashboard ? (
                <DashboardEditMenu
                    dashboard={value}
                    show
                    small
                    allowMove
                    isFavourite={!!isFavourite}
                    onFavouriteChange={toggleFavourite}
                />
            ) : (
                <DashboardFolderEditMenu dashboardFolder={value} show small />
            )}
        </Flex>
    );
}
